import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  menuitemid: null,
  title: null,
  price: 0,
  cost: 0,
  quantity: 0,
  profit: 0,
  periodProfit: 0,
  annualProfit: 0,
  foodCostPercentage: 100,
  archivedMenuItem: false,
};

export default class MenuItemAnalysis extends Record(defaultValues, MenuItemAnalysis) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static getMenuItemAnalysisByMenuItemId(menuItemAnalysis, menuItemId) {
    return menuItemAnalysis.filter((menuItem) => {
      return menuItem.get('menuitemid') === menuItemId;
    });
  }
}

export const MenuItemAnalyses = (data) => {
  let menuItemAnalyses = new List();
  if (data) {
    data.forEach((value) => {
      menuItemAnalyses = menuItemAnalyses.push((value instanceof MenuItemAnalysis) ? value : (new MenuItemAnalysis(value)));
    });
  }
  return menuItemAnalyses;
};
